// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/f53a251e59b78ee46954.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"99752086f3b0f1ff160a","130":"16da9dafa44fab008207","131":"150faa4e483ab7d1b0fe"}[chunkId] + ".chunk.js";
};